import React, { PropTypes } from 'react';
import cn from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';
import { checkedOutItemShape } from '@bibliocommons/bc-prop-types';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import BorrowingBibBrief from '../../shared/BorrowingBibBrief';
import CheckedOutSecondaryInfo from '../CheckedOutSecondaryInfo/CheckedOutSecondaryInfo';
import CheckedOutAdditionalBriefInfo from '../CheckedOutAdditionalBriefInfo';
import RenewButton from '../RenewButton';
import BibListItem from '../../../shared/BibListItem';
import AddToShelfButtonContainer from '../../../../containers/AddToShelfButtonContainer';
import { CheckedOutReadingLinks } from '../../../shared/ItemTransactions';

import './CheckedOutItem.scss';


export default class CheckedOutItem extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleRenew', 'renderSecondaryInfo', 'renderBibBrief', 'startDigitalMissingFormatSelection');
  }

  handleRenew() {
    const { item, accountId, checkoutActions } = this.props;
    const checkoutId = item.get('checkoutId');

    checkoutActions.renew({
      accountId,
      checkoutIds: [checkoutId]
    });
  }

  startDigitalMissingFormatSelection() {
    const { item } = this.props;
    this.props.checkoutActions.startDigitalMissingFormatSelection(
      item.get('checkoutId'),
      item.get('metadataId')
    );
  }

  renderReadingLinks() {
    const { item, accountId, checkoutActions, actionInProgress } = this.props;
    if (item.getIn(['bib', 'policy', 'materialType']) === 'DIGITAL') {
      return (
        <CheckedOutReadingLinks
          disabled={actionInProgress}
          checkInEnabled={item.get('checkInEnabled')}
          downloadable={item.get('downloadable')}
          format={item.get('format')}
          downloadUrl={item.get('downloadUrl')}
          thirdPartyReaderUrl={item.get('thirdPartyReaderUrl')}
          policy={item.getIn(['bib', 'policy', 'materialPolicy'])}
          metadataId={item.get('metadataId')}
          checkoutId={item.get('checkoutId')}
          accountId={accountId}
          checkIn={checkoutActions.digitalCheckIn}
          startDigitalMissingFormatSelection={this.startDigitalMissingFormatSelection} />
      );
    }

    return null;
  }

  renderAddToShelfButton () {
    const { item, shelfTransactions, actionInProgress } = this.props;
    const shelfActionInProgress = !shelfTransactions.get(item.get('metadataId'), Immutable.Map()).isEmpty();

    if (item.get('bib')) {
      return (
        <div className="shelf-button" >
          <AddToShelfButtonContainer
            disabled={actionInProgress && !shelfActionInProgress}
            metadataId={item.get('metadataId')}
            workflowId={item.get('checkoutId')} />
        </div>
      );
    }

    return null;
  }

  renderRenewButton() {
    const { item, checkoutTransactions, actionInProgress } = this.props;
    const checkoutId = item.get('checkoutId');
    const isRenewing = checkoutTransactions.getIn([checkoutId, 'isRenewing']);

    return (
      <RenewButton
        disabled={actionInProgress && !isRenewing}
        isLoading={checkoutTransactions.getIn([checkoutId, 'isRenewing'])}
        canRenew={item.get('actions').contains('renew')}
        canReturn={item.get('actions').contains('checkIn')}
        handleClick={this.handleRenew} />
    );
  }

  renderBibActions() {
    return (
      <div>
        {this.renderReadingLinks()}
        {this.renderRenewButton()}
        {this.renderAddToShelfButton()}
      </div>
    );
  }

  renderSecondaryInfo() {
    const { item } = this.props;
    return (
      <div>
        <div className="checkedout-status">
          <CheckedOutSecondaryInfo item={item} />
        </div>
        {this.renderBibActions()}
      </div>
    );
  }

  renderBibBrief() {
    const briefInfo = this.props.item.getIn(['bib', 'briefInfo']);
    return (
      <BorrowingBibBrief bib={briefInfo} fallbackTitle={this.props.item.get('bibTitle')}>
        <CheckedOutAdditionalBriefInfo
          item={this.props.item}
          rating={this.props.rating}
          ratingsActions={this.props.ratingsActions}
          ratingsTransactions={this.props.ratingsTransactions} />
      </BorrowingBibBrief>
    );
  }

  render() {
    const { item } = this.props;
    return (
      <BibListItem
        workflowId={item.get('checkoutId')}
        className={cn('cp-checked-out-item', item.get('status').toLowerCase())}
        bib={item.getIn(['bib', 'briefInfo'])}
        renderInfo={() => this.renderSecondaryInfo()}
        renderBibBrief={() => this.renderBibBrief()} />
    );
  }
}

CheckedOutItem.propTypes = {
  accountId: PropTypes.number,
  item: checkedOutItemShape,
  actionInProgress: PropTypes.bool,
  checkoutTransactions: ImmutablePropTypes.map,
  ratingsTransactions:  ImmutablePropTypes.map,
  shelfTransactions: ImmutablePropTypes.map,
  rating: ImmutablePropTypes.list,
  checkoutActions: PropTypes.objectOf(PropTypes.func),
  workflowActions: PropTypes.objectOf(PropTypes.func),
  ratingsActions:  PropTypes.objectOf(PropTypes.func)
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutItem/CheckedOutItem.jsx